// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
import _ from 'underscore';

import { isValidHexColor } from 'app/scripts/lib/plugins/pluginValidators';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const pluginCoverWithDefaults = function (pluginCover: any) {
  // Expected Shape of pluginCover
  // {
  //   height: Number
  //   url: string
  //   edgeColor?: string
  //   position?: 'cover' | { padding: boolean, align: 'left'|'right'|'center'}
  // }
  const sanitized = {
    edgeColor: 'transparent',
    height: pluginCover.height,
    size: 'contain',
    padding: '0',
    position: 'center',
    stickerHeight: pluginCover.height,
    url: pluginCover.url,
  };
  // allow for sanctioned overrides
  if (isValidHexColor(pluginCover.edgeColor)) {
    sanitized.edgeColor = pluginCover.edgeColor;
  }
  if (pluginCover.position === 'cover') {
    sanitized.size = 'cover';
  } else if (_.isObject(pluginCover.position)) {
    if (pluginCover.position.padding === true) {
      sanitized.padding = '8px';
      sanitized.stickerHeight += 16;
    }
    if (_.contains(['center', 'left', 'right'], pluginCover.position.align)) {
      sanitized.position = pluginCover.position.align;
    }
  }

  return sanitized;
};
